export default {
  dsnSentry:
    "https://fe1ddce20d8e2d499a99f3da545ed8f3@o4506112487587840.ingest.sentry.io/4506401174781952",
};
